import { createSelector } from 'reselect';

const selectDeliverys = (state: any) => state.deliveries;


export const selectDeliveryCurrentItem = createSelector([selectDeliverys], (deliveries) => deliveries.current);

export const selectDeliverysListItems = createSelector([selectDeliverys], (deliveries) => deliveries.list);

export const selectDeliveryItemById = (itemId: any) =>
    createSelector(selectDeliverysListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDeliveryQueryItems = createSelector([selectDeliverys], (deliveries) => deliveries.query);

export const selectDeliveryCreatedItem = createSelector([selectDeliverys], (deliveries) => deliveries.create);

export const selectDeliveryUpdatedItem = createSelector([selectDeliverys], (deliveries) => deliveries.update);

export const selectDeliveryReadItem = createSelector([selectDeliverys], (deliveries) => deliveries.read);

export const selectDeliveryDeletedItem = createSelector([selectDeliverys], (deliveries) => deliveries.delete);

export const selectDeliverySearchedItems = createSelector([selectDeliverys], (deliveries) => deliveries.search);

export const selectDeliveryItemsCount = createSelector([selectDeliverys], (deliveries) => deliveries.count);

export const selectDeliveryItemsFilter = createSelector([selectDeliverys], (deliveries) => deliveries.filter);